export default {
  name: 'highContrast',

  anchor: '#1034a6',
  anchorVisited: '#440381',
  borderDark: '#888c8f',
  borderDarkest: '#ffffff',
  borderLight: '#dfe0e3',
  borderLightest: '#ffffff',
  canvas: '#353535',
  canvasText: '#ffffff',
  canvasTextDisabled: '#888c8f',
  canvasTextDisabledShadow: '#ffffff',
  canvasTextInvert: '#ffffff',
  checkmark: '#ffffff',
  checkmarkDisabled: '#888c8f',
  flatDark: '#9e9e9e',
  flatLight: '#d8d8d8',
  focusSecondary: '#fefe03',
  headerBackground: '#8e0284',
  headerNotActiveBackground: '#7f7f7f',
  headerNotActiveText: '#ced0cf',
  headerText: '#ffffff',
  hoverBackground: '#8e0284',
  material: '#000000',
  materialDark: '#9a9e9c',
  materialText: '#ffffff',
  materialTextDisabled: '#888c8f',
  materialTextDisabledShadow: '#ffffff',
  materialTextInvert: '#ffffff',
  progress: '#8e0284',
  tooltip: '#fefbcc'
};
